import React, {Component} from "react";
import "./MonthlyReport.scss"
import GroupNav from '../DownloadReport/GroupNav';
import DatePicker from 'react-datepicker';
import moment from "moment";
import {schemaTypes} from '../../../../constants/constants'
import ReportAPIs from "../../../../APIs/ReportAPIs";
import GroupTable from '../GroupReport/groupTable';
import ReusableGraph from '../ReusableGraph/ReusableGraph';
import InMultiSelect from '../InMultiSelect/InMultiSelect';
import { JSONToCSVConvertor } from '../../../../helpers/helperFunctions';

class MonthlyReport extends Component{
    constructor(props){
        super(props)
        this.props = props
        this.state = {
            utilization_type: "",
            reportName: "",
            dropdownOpen: false,
            startDate: moment().subtract(1, "month").startOf("day").toDate(),
            endDate: moment().subtract(1, "day").endOf("day").toDate(),
            selectAllGroups: false,
            groups: [],
            selectedGroup: {},
            vehicleIds: [],
            selectedVehicleId: null, // For battery swap report single vehicle selection
            tableData: [],
            columns: [],
            graphData: null,
            busy: false,
            errorPage: false,
            canDownload: false,
            vehicleUsageSummary: null,
            vehicleUsageGraphData: null,
            vehicleUsageRawData: null, // Store full response for table display
            selectedGroupForTable: null, // Store selected group data for table
            showVehicleUsagePopup: false, // Control popup visibility
        }
        this.group = []
        this.vehicleSelect = React.createRef();
        
        // Header name mapping: API key -> Display name
        this.headerMapping = {
            'regno': 'Reg No',
            'vinno': 'VIN No',
            'make': 'Make',
            'model': 'Model',
            'month': 'Month',
            'totaldistance': 'Total Distance(KM)',
            'totalsoconsumed': 'Total SoC Consumed(%)',
            'startodometer': 'Start Odometer(KM)',
            'endodometer': 'End Odometer(KM)',
            'groupname': 'Group Name',
            'subgroupname': 'Sub Group Name',
            'currentodo': 'Current ODO',
            'time': 'Time',
            'isoperational': 'Operational',
            'vin': 'VIN No',
            'vehicleno': 'Vehicle No',
            'swaptimestamp': 'Swap Time',
            'socbefore': 'SoC Before',
            'socafter': 'SoC After',
            'socchange': 'SoC Change',
            // Vehicle usage bucketing
            'kmbelow10': 'Km below 10',
            'kmbelow20': 'Km below 20',
            'kmbelow30': 'Km below 30',
            'kmabove30': 'Km above 30',
            // Add more mappings as needed
        };
    }

    componentDidMount(){
        this.handleClickOutside = (e) => {
            let container = document.querySelector('.mrc-report-type');
            if (container && !container.contains(e.target)) {
                this.setState({dropdownOpen: false});
            }
        };
        document.addEventListener('mousedown', this.handleClickOutside);
        
        // Handle ESC key for closing modal
        this.handleEscKey = (e) => {
            if ((e.key === 'Escape' || e.keyCode === 27) && this.state.showVehicleUsagePopup) {
                e.preventDefault();
                this.handleVehicleUsagePopupClose();
            }
        };
        document.addEventListener('keydown', this.handleEscKey);
        
        // Fix gap between tabs and content
        window.$('.rw-container').css('top', '53px');

        // Initialize group tree (without collecting vehicles)
        let group = this.props.props.groupTree;
        if(!group.path){
            group.path = "/0/";
            group.ppath = "/0/";
        }
        this.group = group;
        // Initialize groups state without navigating (no vehicle collection on load)
        let rootGroupPath = "";
        let nav = [];
        nav.push(this.group);
        this.setState({groups: nav});
    }

    componentWillUnmount() {
        if (this.handleClickOutside) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
        
        if (this.handleEscKey) {
            document.removeEventListener('keydown', this.handleEscKey);
        }
        
        // Remove the top style when component unmounts
        window.$('.rw-container').attr('style', function(i, style)
        {
            return style && style.replace(/top[^;]+;?/g, '');
        });
    }

    toggleDropdown = () => {
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    };

    handleOptionClick = (value, name) => {
        const isBatterySwap = value === "battery-swap";
        const isVehicleUsage = value === "vehicle-usage";
        const isSwitchingToVehicleUsage = isVehicleUsage && this.state.utilization_type !== "vehicle-usage";

        // Clear window-selected vehicles only for battery swap to ensure fresh list
        if (isBatterySwap) {
            window.selectedVehicles = [];
            window.selectedItems = [];
        }

        this.setState(
            {
                utilization_type: value,
                reportName: name,
                dropdownOpen: false,
                selectedVehicleId: null, // Reset vehicle selection when changing report type
                // Reset group selections for battery-swap, or when switching TO vehicle-usage (not if already on vehicle-usage)
                selectAllGroups: (isBatterySwap || isSwitchingToVehicleUsage) ? false : this.state.selectAllGroups,
                selectedGroup: isBatterySwap ? {} : (isSwitchingToVehicleUsage ? {} : this.state.selectedGroup),
                vehicleIds: (isBatterySwap || isSwitchingToVehicleUsage) ? [] : this.state.vehicleIds,
                // Clear any previously shown data when switching report
                tableData: [],
                columns: [],
                graphData: null,
                canDownload: false,
                errorPage: false,
                vehicleUsageSummary: null,
                vehicleUsageGraphData: null,
                vehicleUsageRawData: null,
                showVehicleUsagePopup: false,
            },
            () => {
                // Force InMultiSelect to refresh its data after state update for battery-swap
                if (isBatterySwap && this.vehicleSelect && this.vehicleSelect.current) {
                    if (this.vehicleSelect.current.setData && this.props.props.store) {
                        const vehicleData = (() => {
                            let newMap = {};
                            for (let idx in this.props.props.store.vehicleMap) {
                                if (idx.indexOf("user") === -1) {
                                    newMap[idx] = this.props.props.store.vehicleMap[idx];
                                }
                            }
                            return {
                                data: newMap,
                                name: "vehicleno",
                                id: "vehicleid",
                            };
                        })();
                        this.vehicleSelect.current.setData(vehicleData);
                    }
                }
            }
        );
    };

    changeVehicle = (selectedItems) => {
        window.saveVehicleState(selectedItems);
        // For single select, get the first item's ID
        const vehicleId = selectedItems && selectedItems.length > 0 
            ? (selectedItems[0].id || (selectedItems[0].data && selectedItems[0].data.vehicleid) || selectedItems[0].vehicleid)
            : null;
        this.setState({ selectedVehicleId: vehicleId });
    }

    getReportType = () => {
        const reportTypes = [
            { key: "utilization-report", name: "Utilization Report" },
            { key: "utilization-graph", name: "Utilization Graph" },
            { key: "operational-status", name: "Operational Status" },
            { key: "battery-swap", name: "Battery Swap Report" },
            { key: "vehicle-usage", name: "Vehicle Usage Report" },
        ];
        
        return reportTypes.map((report, index) => {
            return (
                <div
                    key={index}
                    className="dropdown-option"
                    onClick={() => this.handleOptionClick(report.key, report.name)}
                >
                    {report.name}
                </div>
            );
        });
    };

    handleStartDate = (date) => {
        // If operational-status is selected, show disabled message
        if (this.state.utilization_type === "operational-status") {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                    name: "Date Selection Disabled",
                    content: "Date selection is disabled for Operational Status report.",
                    createAt: Date.now(),
                    autoClose: 4000,
                    showError: true
                },
            });
            return;
        }
        // Set start date to 00:00 (midnight) of the selected date
        const startDateWithTime = moment(date).startOf("day").toDate();
        this.setState({startDate: startDateWithTime})
    }

    handleEndDate = (date) => {
        // If operational-status is selected, show disabled message
        if (this.state.utilization_type === "operational-status") {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                    name: "Date Selection Disabled",
                    content: "Date selection is disabled for Operational Status report.",
                    createAt: Date.now(),
                    autoClose: 4000,
                    showError: true
                },
            });
            return;
        }
        // Set end date to 23:59 (11:59 PM) of the selected date
        const endDateWithTime = moment(date).endOf("day").toDate();
        this.setState({endDate: endDateWithTime})
    }

    // Collect only immediate subgroup IDs (direct children only, not nested)
    collectSubGroupIds = (group) => {
        let subgroupIds = [];
        
        if (!group) {
            return subgroupIds;
        }

        console.log("collectSubGroupIds - Parent Group:", group.name || group.groupname, "GroupID:", group.groupid);

        // Collect only immediate children's groupids (not nested subgroups)
        if (group.children && Array.isArray(group.children)) {
            group.children.forEach(childGroup => {
                if (childGroup && typeof childGroup === 'object') {
                    // Include only the immediate child group's groupid if it exists and is not 0 (Users group)
                    if (childGroup.groupid !== undefined && childGroup.groupid !== null && childGroup.groupid !== 0) {
                        console.log("collectSubGroupIds - Child Group:", childGroup.name || childGroup.groupname, "GroupID:", childGroup.groupid);
                        subgroupIds.push(childGroup.groupid);
                    }
                    // Do not recursively collect from nested children - only immediate children
                }
            });
        }
        
        console.log("collectSubGroupIds - Collected subgroup IDs:", subgroupIds);
        // Remove duplicates
        return [...new Set(subgroupIds)];
    }
    // Recursively collect vehicle IDs from a group and all its sub-groups
    collectVehicleIdsFromGroup = (group) => {
        let vehicleIds = [];
        
        if (!group) {
            return vehicleIds;
        }

        // Collect vehicles from current group
        if (group.vehicles && Array.isArray(group.vehicles)) {
            group.vehicles.forEach(vehicle => {
                const vehicleId = vehicle.id || vehicle.vehicleid || vehicle.userid;
                if (vehicleId) {
                    vehicleIds.push(vehicleId);
                }
            });
        }

        // Also collect from users array (some groups have users instead of vehicles)
        if (group.users && Array.isArray(group.users)) {
            group.users.forEach(user => {
                const vehicleId = user.id || user.userid || user.vehicleid;
                if (vehicleId) {
                    vehicleIds.push(vehicleId);
                }
            });
        }

        // Recursively collect vehicles from all sub-groups
        // Process all children groups, including those with groupid === 0 (like "Users" group)
        if (group.children && Array.isArray(group.children)) {
            group.children.forEach(childGroup => {
                // Process all valid child groups (including groupid === 0)
                if (childGroup && typeof childGroup === 'object') {
                    const childVehicleIds = this.collectVehicleIdsFromGroup(childGroup);
                    vehicleIds = [...vehicleIds, ...childVehicleIds];
                }
            });
        }

        // Remove duplicates (in case a vehicle appears in multiple groups)
        return [...new Set(vehicleIds)];
    }

    navigate = (group) => {
        console.log("navigate called - Group Name:", group.name || group.groupname, "GroupID:", group.groupid);
        
        let rootGroupPath = "";
        let path = group.path;
        let pathArray = path.split("/");
        pathArray.splice(0,1);
        pathArray = pathArray.splice(0, pathArray.length-1);
        let currentPath = rootGroupPath;
        let nav = [];
        let currentNode = this.group;
        nav.push(currentNode);
        for(let idx in pathArray){
            currentPath += "/" + pathArray[idx];
            for(let jdx in currentNode.children){
                if(currentNode.children[jdx].path === currentPath + "/"){
                    currentNode = currentNode.children[jdx];
                    if(!("children" in currentNode))
                        currentNode.children = [];
                    nav.push(currentNode);
                    break;
                }
            }
        }
        
        // Collect vehicle IDs from the selected group and all its sub-groups
        const vehicleIds = this.collectVehicleIdsFromGroup(group);
        
        console.log("navigate - Setting selectedGroup:", group.name || group.groupname, "GroupID:", group.groupid);
        this.setState({groups: nav, selectedGroup: group, vehicleIds: vehicleIds}, () => {
            console.log("navigate - State updated. Current selectedGroup:", this.state.selectedGroup);
        });
    }

    toggleSelectAllGroups = () => {
        const newSelectAllGroups = !this.state.selectAllGroups;
        console.log("toggleSelectAllGroups called - newSelectAllGroups:", newSelectAllGroups, "current selectedGroup:", this.state.selectedGroup);
        
        if (newSelectAllGroups) {
            // Collect all vehicles from the main group tree and all sub-groups
            const vehicleIds = this.collectVehicleIdsFromGroup(this.group);
            this.setState({
                selectAllGroups: true, 
                vehicleIds: vehicleIds,
                selectedGroup: {} // Clear selected group when selecting all
            });
        } else {
            // Clear vehicle IDs and selected group when unchecking
            this.setState({
                selectAllGroups: false, 
                vehicleIds: [],
                selectedGroup: {}
            });
        }
    }

    // Validate if all required fields are filled
    isFormValid = () => {
        // Check if report type is selected
        const hasReportType = this.state.utilization_type !== "" && 
                             this.state.utilization_type !== null && 
                             this.state.utilization_type !== undefined;
        
        // For operational-status, only report type is required (vehicles can be selected later or from window.selectedItems)
        if (this.state.utilization_type === "operational-status") {
            return hasReportType;
        }
        
        // For battery-swap, require report type and a vehicle selection
        if (this.state.utilization_type === "battery-swap") {
            // Check if a vehicle is selected from the InMultiSelect component
            const hasVehicle = this.state.selectedVehicleId !== null && 
                              this.state.selectedVehicleId !== undefined;
            
            // Also check window.selectedItems and window.selectedVehicles as fallback
            const hasVehicleFromWindow = (window.selectedItems && window.selectedItems.length > 0) ||
                                        (window.selectedVehicles && window.selectedVehicles.length > 0);
            
            return hasReportType && (hasVehicle || hasVehicleFromWindow);
        }
        // For vehicle-usage, require report type, dates, and at least one vehicle (from group selection or window caches)
        if (this.state.utilization_type === "vehicle-usage") {
            const hasReportType = true; // already true here
            const hasStartDate = this.state.startDate !== null && this.state.startDate !== undefined;
            const hasEndDate = this.state.endDate !== null && this.state.endDate !== undefined;
            // vehicleIds populated from group selection; fallback to window selections
            const hasVehicles = (this.state.vehicleIds && this.state.vehicleIds.length > 0) ||
                (window.selectedItems && window.selectedItems.length > 0) ||
                (window.selectedVehicles && window.selectedVehicles.length > 0);
            return hasReportType && hasStartDate && hasEndDate && hasVehicles;
        }
        
        // For other date-based reports, require vehicles/groups and dates
        // Check if group/vehicles are selected
        // Either "Select All Groups" is checked OR a specific group is selected (with valid groupid)
        const hasGroupOrVehicles = this.state.selectAllGroups || 
            (this.state.selectedGroup && 
             this.state.selectedGroup.groupid !== undefined && 
             this.state.selectedGroup.groupid !== null &&
             Object.keys(this.state.selectedGroup).length > 0);
        
        // Check if start date is selected
        const hasStartDate = this.state.startDate !== null && this.state.startDate !== undefined;
        
        // Check if end date is selected
        const hasEndDate = this.state.endDate !== null && this.state.endDate !== undefined;
        
        return hasGroupOrVehicles && hasStartDate && hasEndDate && hasReportType;
    }

    // Process API response and generate columns dynamically
    processResponseData = (response) => {
        if (!response || !Array.isArray(response) || response.length === 0) {
            return { data: [], columns: [] };
        }

        // Get all unique keys from the response objects
        const allKeys = new Set();
        response.forEach(item => {
            Object.keys(item).forEach(key => allKeys.add(key));
        });

        // Generate columns from keys with header mapping
        const columns = Array.from(allKeys).map(key => {
            // Check if there's a mapping for this key
            const mappedName = this.headerMapping[key.toLowerCase()];
            
            // If mapping exists, use it; otherwise format the key
            const displayName = mappedName || 
                (key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '));
            
            return {
                key: key,
                name: displayName
            };
        });

        // Format data - ensure all items have all keys (fill missing with empty string)
        const data = response.map(item => {
            const formattedItem = {};
            columns.forEach(col => {
                let value = item[col.key];
                
                // Handle boolean values - convert to "Yes" or "No"
                if (typeof value === 'boolean') {
                    value = value ? 'Yes' : 'No';
                }
                // Handle null/undefined
                else if (value === undefined || value === null) {
                    value = '';
                }
                
                formattedItem[col.key] = value;
            });
            return formattedItem;
        });

        return { data, columns };
    }

    // Process graph data from API response
    processGraphData = (response) => {
        // Handle both direct array and object with data property
        let data = null;
        if (Array.isArray(response)) {
            data = response;
        } else if (response && response.data && Array.isArray(response.data)) {
            data = response.data;
        }
        
        if (!data || data.length === 0) {
            return null;
        }
        
        // Extract dates for x-axis (all days)
        const dates = data.map(item => item.date || moment(item.daystarttime).format('DD-MMM-YYYY'));
        
        // Extract data for each series (all days)
        const totalOdometer = data.map(item => item.totalodometer || 0);
        const totalDistance = data.map(item => item.totaldistance || 0);
        const totalSoConsumed = data.map(item => item.totalsoconsumed || 0);

        // Calculate kilometer difference: data[1] - data[0], data[2] - data[1], etc.
        // Kilometer difference starts from 2nd day (first day will be null)
        // Format to 2 decimal places
        const kilometerDifference = [];
        for (let i = 0; i < totalDistance.length; i++) {
            if (i === 0) {
                // First day: no difference (null or 0)
                kilometerDifference.push(null);
            } else {
                // Calculate difference: current - previous, rounded to 2 decimal places
                const difference = totalDistance[i] - totalDistance[i - 1];
                kilometerDifference.push(parseFloat(difference.toFixed(2)));
            }
        }

        return {
            dates,
            totalOdometer,
            kilometerDifference,
            totalDistance,
            totalSoConsumed
        };
    }

    // Process vehicle usage report graph data
    processVehicleUsageGraphData = (response) => {
        // Response should be an array of group data
        if (!response || !Array.isArray(response) || response.length === 0) {
            return null;
        }

        // Extract group names for x-axis
        const groupNames = response.map(item => item.groupname || 'Unknown');
        
        // Extract noofvehicles and operationalvehicles for y-axis
        const noofvehicles = response.map(item => item.noofvehicles || 0);
        const operationalvehicles = response.map(item => item.operationalvehicles || 0);

        return {
            groupNames,
            noofvehicles,
            operationalvehicles,
            rawData: response // Store full data for table display
        };
    }

    // Get vehicle usage graph configuration
    getVehicleUsageGraphConfig = () => {
        const { vehicleUsageGraphData } = this.state;
        
        if (!vehicleUsageGraphData) {
            return null;
        }

        return {
            type: 'bar',
            data: vehicleUsageGraphData.groupNames,
            xAxisData: vehicleUsageGraphData.groupNames,
            series: [
                {
                    name: 'No of Vehicles',
                    type: 'bar',
                    data: vehicleUsageGraphData.noofvehicles,
                    itemStyle: {
                        color: '#5470c6'
                    }
                },
                {
                    name: 'Operational Vehicles',
                    type: 'bar',
                    data: vehicleUsageGraphData.operationalvehicles,
                    itemStyle: {
                        color: '#91cc75'
                    }
                }
            ],
            options: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    bottom: 100,
                    left: 60,
                    right: 60,
                    top: 60
                },
                legend: {
                    data: ['No of Vehicles', 'Operational Vehicles'],
                    bottom: 0
                },
                xAxis: {
                    type: 'category',
                    data: vehicleUsageGraphData.groupNames,
                    axisLabel: {
                        rotate: 45,
                        interval: 0
                    }
                },
                yAxis: {
                    type: 'value',
                    name: 'Number of Vehicles'
                },
            }
        };
    }

    // Handle bar click in vehicle usage graph
    handleVehicleUsageBarClick = (params) => {
        const { vehicleUsageGraphData } = this.state;
        
        if (!vehicleUsageGraphData || !vehicleUsageGraphData.rawData) {
            return;
        }

        // params from ECharts click event contains seriesName, name, value, etc.
        // name is the group name (x-axis value)
        const groupName = params.name;
        
        if (!groupName) {
            return;
        }
        
        // Find the corresponding group data
        const groupData = vehicleUsageGraphData.rawData.find(item => 
            (item.groupname || 'Unknown') === groupName
        );

        if (groupData && groupData.vehiclebucketing) {
            // Process the vehicle bucketing data for table display
            const { data, columns } = this.processResponseData(groupData.vehiclebucketing);
            
            this.setState({
                selectedGroupForTable: groupData,
                tableData: data,
                columns: columns,
                canDownload: data.length > 0,
                showVehicleUsagePopup: true // Show popup
            });
        } else {
            // If no vehiclebucketing, clear and don't show popup
            this.setState({
                selectedGroupForTable: null,
                tableData: [],
                columns: [],
                showVehicleUsagePopup: false
            });
        }
    }

    // Handle popup close
    handleVehicleUsagePopupClose = () => {
        this.setState({
            showVehicleUsagePopup: false,
            selectedGroupForTable: null,
            tableData: [],
            columns: []
        });
    }

    // Get graph configuration for ReusableGraph component
    getGraphConfig = () => {
        const { graphData } = this.state;
        
        if (!graphData) {
            return null;
        }

        return {
            type: 'mixed', // Mixed line and bar chart
            data: graphData.dates, // X-axis data
            xAxisData: graphData.dates,
            series: [
                {
                    name: 'Kilometer Difference',
                    type: 'line',
                    yAxisIndex: 1,
                    data: graphData.kilometerDifference,
                    smooth: true,
                    itemStyle: {
                        color: '#5470c6'
                    }
                },
                {
                    name: 'Total Distance',
                    type: 'bar',
                    yAxisIndex: 0,
                    data: graphData.totalDistance,
                    itemStyle: {
                        color: '#91cc75'
                    }
                },
                {
                    name: 'Total SoC Consumed',
                    type: 'bar',
                    yAxisIndex: 0,
                    data: graphData.totalSoConsumed,
                    itemStyle: {
                        color: '#fac858'
                    }
                }
            ],
            options: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    },
                    formatter: function(params) {
                        let result = params[0].name + '<br/>';
                        params.forEach(function(item) {
                            if (item.seriesName === 'Kilometer Difference') {
                                const value = item.value !== null && item.value !== undefined ? item.value.toFixed(2) : '-';
                                result += item.marker + item.seriesName + ': ' + value + '<br/>';
                            } else {
                                result += item.marker + item.seriesName + ': ' + item.value + '<br/>';
                            }
                        });
                        return result;
                    }
                },
                grid: {
                    bottom: 150, // Add more bottom padding to accommodate rotated labels and legend
                    left: 60,
                    right: 60,
                    top: 60
                },
                legend: {
                    data: ['Kilometer Difference', 'Total Distance', 'Total SoC Consumed'],
                    bottom: 0 // Position legend at the very bottom
                },
                xAxis: {
                    rotate: 90, // Rotate labels 90 degrees (vertical)
                    interval: 0, // Show all labels (no skipping)
                    axisLabel: {
                        margin: 10 // Add margin between labels and axis
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: 'Distance / SoC',
                        position: 'left',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                    {
                        type: 'value',
                        name: 'Kilometer Difference',
                        position: 'right',
                        axisLabel: {
                            formatter: function(value) {
                                return value !== null && value !== undefined ? value.toFixed(2) : '';
                            }
                        }
                    }
                ]
            }
        };
    }

    downloadReport = () => {
        const { tableData, columns, utilization_type, graphData, vehicleUsageGraphData } = this.state;

        const toast = (name, content, showError = false) => {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                    name,
                    content,
                    createAt: Date.now(),
                    autoClose: 4000,
                    showError
                },
            });
        };

        // No data guard
        if (utilization_type === "utilization-report") {
            if (!tableData || !tableData.length) {
                toast("No Data", "No table data available to download.", true);
                return;
            }

            // Build rows using column display names
            let rows = [];
            const cols = (columns && columns.length) ? columns : Object.keys(tableData[0] || {}).map(k => ({ key: k, name: k }));
            tableData.forEach(item => {
                let row = {};
                cols.forEach(col => {
                    row[col.name || col.key] = item[col.key];
                });
                rows.push(row);
            });

            const stamp = moment().format("YYYY_MM_DD_HH_mm_ss");
            JSONToCSVConvertor(rows, `Utilization_Report_${stamp}`, false, true, false);
            toast("Download", `Utilization report downloaded (${stamp}).`);
        } else if (utilization_type === "utilization-graph") {
            if (!graphData) {
                toast("No Data", "No graph data available to download.", true);
                return;
            }

            // Flatten graph data to CSV rows
            const { dates, kilometerDifference, totalDistance, totalSoConsumed } = graphData;
            const rows = dates.map((date, idx) => ({
                Date: date,
                "Kilometer Difference": kilometerDifference[idx] !== null && kilometerDifference[idx] !== undefined 
                    ? parseFloat(kilometerDifference[idx]).toFixed(2) 
                    : '',
                "Total Distance": totalDistance[idx],
                "Total SoC Consumed": totalSoConsumed[idx],
            }));

            const stamp = moment().format("YYYY_MM_DD_HH_mm_ss");
            JSONToCSVConvertor(rows, `Utilization_Graph_${stamp}`, false, true, false);
            toast("Download", `Utilization graph data downloaded (${stamp}).`);
        } else if (utilization_type === "vehicle-usage") {
            if (!vehicleUsageGraphData || !vehicleUsageGraphData.rawData || vehicleUsageGraphData.rawData.length === 0) {
                toast("No Data", "No vehicle usage data available to download.", true);
                return;
            }

            // Build rows with group name, no of vehicles, operational vehicles, and non operational vehicles
            const rows = vehicleUsageGraphData.rawData.map(item => ({
                "Group Name": item.groupname || 'Unknown',
                "No of Vehicles": item.noofvehicles || 0,
                "Operational Vehicles": item.operationalvehicles || 0,
                "Non Operational Vehicles": item.nonoperationalvehicles || 0
            }));

            const stamp = moment().format("YYYY_MM_DD_HH_mm_ss");
            JSONToCSVConvertor(rows, `Vehicle_Usage_Report_${stamp}`, false, true, false);
            toast("Download", `Vehicle usage report downloaded (${stamp}).`);
        } else {
            // Table downloads for all other report types
            if (!tableData || !tableData.length) {
                toast("No Data", "No table data available to download.", true);
                return;
            }

            const typeToName = {
                "utilization-report": "Utilization_Report",
                "operational-status": "Operational_Status_Report",
                "battery-swap": "Battery_Swap_Report",
                "vehicle-usage": "Vehicle_Usage_Report",
            };

            let rows = [];
            const cols = (columns && columns.length) ? columns : Object.keys(tableData[0] || {}).map(k => ({ key: k, name: k }));
            tableData.forEach(item => {
                let row = {};
                cols.forEach(col => {
                    row[col.name || col.key] = item[col.key];
                });
                rows.push(row);
            });

            const stamp = moment().format("YYYY_MM_DD_HH_mm_ss");
            const filename = typeToName[utilization_type] || "Report";
            JSONToCSVConvertor(rows, `${filename}_${stamp}`, false, true, false);
            toast("Download", `${filename.replace(/_/g, " ")} downloaded (${stamp}).`);
        }
    }

    getReport = () => {
        if (!this.isFormValid()) {
            return;
        }
        
        const { utilization_type, vehicleIds, startDate, endDate } = this.state;
        
        // Log state before setting busy
        console.log("getReport - Before setState - selectedGroup:", this.state.selectedGroup);
        
        // Set loading state (preserve selectedGroup)
        this.setState({ busy: true, errorPage: false, tableData: [], columns: [], graphData: null, canDownload: false });
        
        // Handle battery-swap report (requires vehicle and dates)
        if (utilization_type === "battery-swap") {
            // Get vehicle ID from state or fallback to window.selectedItems
            let finalVehicleId = this.state.selectedVehicleId;
            
            if (!finalVehicleId) {
                // Fallback to window.selectedItems
                if (window.selectedItems && window.selectedItems.length > 0) {
                    finalVehicleId = window.selectedItems[0].id || 
                                   (window.selectedItems[0].data && window.selectedItems[0].data.vehicleid) || 
                                   window.selectedItems[0].vehicleid;
                }
                // Fallback to window.selectedVehicles
                else if (window.selectedVehicles && window.selectedVehicles.length > 0) {
                    finalVehicleId = window.selectedVehicles[0].id || 
                                   (window.selectedVehicles[0].data && window.selectedVehicles[0].data.vehicleid) || 
                                   window.selectedVehicles[0].vehicleid;
                }
            }
            
            if (!finalVehicleId) {
                this.props.props.dispatch({
                    type: "ADD_INTOAST",
                    data: {
                        name: "No Vehicle Selected",
                        content: "Please select a vehicle to get the battery swap report.",
                        createAt: Date.now(),
                        autoClose: 4000,
                        showError: true
                    },
                });
                this.setState({ busy: false });
                return;
            }
            
            // Convert dates to timestamps
            const starttime = moment(startDate).unix() * 1000;
            const endtime = moment(endDate).unix() * 1000;
            
            const body = {
                vehicleids: [finalVehicleId], // API expects array
                starttime: starttime,
                endtime: endtime
            };
            
            ReportAPIs.getBatterySwapReport(body)
                .then((response) => {
                    // Process response data for table display
                    const { data, columns } = this.processResponseData(response);
                    
                    this.setState({
                        tableData: data,
                        columns: columns,
                        graphData: null,
                        busy: false,
                        errorPage: data.length === 0,
                        canDownload: data.length > 0
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Generated",
                            content: "Battery swap report generated successfully.",
                            createAt: Date.now(),
                            autoClose: 4000,
                            showError: false
                        },
                    });
                })
                .catch((error) => {
                    console.error("Battery Swap Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: [],
                        graphData: null,
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch battery swap report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
            return;
        }

        // Handle vehicle-usage report (requires vehicles/groups and dates)
        if (utilization_type === "vehicle-usage") {
            // Read selectedGroup directly from state to ensure we have the latest value
            let currentSelectedGroup = this.state.selectedGroup;
            console.log("getReport - vehicle-usage - Current state selectedGroup:", currentSelectedGroup);
            console.log("getReport - vehicle-usage - selectedGroup keys:", currentSelectedGroup ? Object.keys(currentSelectedGroup) : "null/undefined");
            console.log("getReport - vehicle-usage - Full state:", this.state);
            
            // Fallback: If selectedGroup is empty but we have groups in navigation, use the last group
            if ((!currentSelectedGroup || Object.keys(currentSelectedGroup).length === 0) && this.state.groups && this.state.groups.length > 0) {
                // The last item in groups array is the currently selected group
                const lastGroup = this.state.groups[this.state.groups.length - 1];
                if (lastGroup && lastGroup.groupid !== undefined && lastGroup.groupid !== 0) {
                    console.log("getReport - vehicle-usage - Recovered selectedGroup from groups array:", lastGroup.name || lastGroup.groupname, "GroupID:", lastGroup.groupid);
                    currentSelectedGroup = lastGroup;
                }
            }
            
            // Use vehicleIds collected from group selection
            let finalVehicleIds = vehicleIds;
            // Fallback to window selections if empty
            if (!finalVehicleIds || finalVehicleIds.length === 0) {
                if (window.selectedItems && window.selectedItems.length > 0) {
                    finalVehicleIds = window.selectedItems.map(item => item.id || (item.data && item.data.vehicleid) || item.vehicleid).filter(Boolean);
                } else if (window.selectedVehicles && window.selectedVehicles.length > 0) {
                    finalVehicleIds = window.selectedVehicles.map(item => item.id || (item.data && item.data.vehicleid) || item.vehicleid).filter(Boolean);
                }
            }

            if (!finalVehicleIds || finalVehicleIds.length === 0) {
                this.props.props.dispatch({
                    type: "ADD_INTOAST",
                    data: {
                        name: "No Vehicles Selected",
                        content: "Please select at least one vehicle or group to get the report.",
                        createAt: Date.now(),
                        autoClose: 4000,
                        showError: true
                    },
                });
                this.setState({ busy: false });
                return;
            }

            const starttime = moment(startDate).unix() * 1000;
            const endtime = moment(endDate).unix() * 1000;

            // Collect only immediate subgroupids from selected group, or empty array if no group selected
            let groupids = [];
            if (currentSelectedGroup && currentSelectedGroup.groupid !== undefined && currentSelectedGroup.groupid !== null) {
                console.log("Vehicle Usage Report - Selected Group Name:", currentSelectedGroup.name || currentSelectedGroup.groupname);
                console.log("Vehicle Usage Report - Selected Group ID:", currentSelectedGroup.groupid);
                
                // Collect only immediate subgroups (child groups), not the parent group itself
                const subgroupids = this.collectSubGroupIds(currentSelectedGroup);
                groupids = [...subgroupids];
                console.log("Vehicle Usage Report - Final groupids array (child groups only):", groupids);
            } else {
                console.log("Vehicle Usage Report - No group selected, groupids will be empty array");
                console.log("Vehicle Usage Report - currentSelectedGroup value:", currentSelectedGroup);
            }

            const body = {
                vehicleids: finalVehicleIds,
                starttime,
                endtime,
                groupids: groupids,
            };
            
            console.log("Vehicle Usage Report - Request body:", body);

            ReportAPIs.getVehicleUsageReport(body)
                .then((response) => {
                    
                    // Process graph data from response
                    const graphData = this.processVehicleUsageGraphData(response);
                    
                    this.setState({
                        vehicleUsageGraphData: graphData,
                        vehicleUsageRawData: response,
                        tableData: [], // Clear table initially, will show on bar click
                        columns: [],
                        busy: false,
                        errorPage: !graphData,
                        canDownload: !!graphData
                    });
                    
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Generated",
                            content: "Vehicle usage report generated successfully.",
                            createAt: Date.now(),
                            autoClose: 4000,
                            showError: false
                        },
                    });
                })
                .catch((error) => {
                    console.error("Vehicle Usage Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: [],
                        graphData: null,
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch vehicle usage report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
            return;
        }
        
        // Handle operational-status report (no dates required)
        if (utilization_type === "operational-status") {
            // Get vehicle IDs from state or fallback to window.selectedItems
            let finalVehicleIds = vehicleIds;
            
            if (!finalVehicleIds || finalVehicleIds.length === 0) {
                // Fallback to window.selectedItems
                if (window.selectedItems && window.selectedItems.length > 0) {
                    finalVehicleIds = window.selectedItems.map(item => {
                        return item.id || (item.data && item.data.vehicleid) || item.vehicleid;
                    }).filter(id => id !== undefined && id !== null);
                }
                // Fallback to window.selectedVehicles
                else if (window.selectedVehicles && window.selectedVehicles.length > 0) {
                    finalVehicleIds = window.selectedVehicles.map(item => {
                        return item.id || (item.data && item.data.vehicleid) || item.vehicleid;
                    }).filter(id => id !== undefined && id !== null);
                }
            }
            
            if (!finalVehicleIds || finalVehicleIds.length === 0) {
                this.props.props.dispatch({
                    type: "ADD_INTOAST",
                    data: {
                        name: "No Vehicles Selected",
                        content: "Please select at least one vehicle or group to get the report.",
                        createAt: Date.now(),
                        autoClose: 4000,
                        showError: true
                    },
                });
                this.setState({ busy: false });
                return;
            }
            
            const body = {
                vehicleids: finalVehicleIds
            };
            
            // Add groupid if a group is selected
            if (this.state.selectedGroup && this.state.selectedGroup.groupid !== undefined && this.state.selectedGroup.groupid !== null) {
                body.groupid = this.state.selectedGroup.groupid;
            }
            
            ReportAPIs.getOperationalStatusReport(body)
                .then((response) => {
                    // Process response data for table display
                    const { data, columns } = this.processResponseData(response);
                    
                    this.setState({
                        tableData: data,
                        columns: columns,
                        graphData: null,
                        busy: false,
                        errorPage: data.length === 0,
                        canDownload: data.length > 0
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Generated",
                            content: "Operational status report generated successfully.",
                            createAt: Date.now(),
                            autoClose: 4000,
                            showError: false
                        },
                    });
                })
                .catch((error) => {
                    console.error("Operational Status Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: [],
                        graphData: null,
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch operational status report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
            return;
        }
        
        // Convert dates to timestamps for other report types
        const starttime = moment(startDate).unix() * 1000;
        const endtime = moment(endDate).unix() * 1000;
        
        // Prepare request body
        const body = {
            vehicleids: vehicleIds,
            utilization_type: utilization_type,
            starttime: starttime,
            endtime: endtime
        };
        
        // Call appropriate API based on utilization_type
        if (utilization_type === "utilization-report") {
            ReportAPIs.getUtilizationReport(body)
                .then((response) => {
                    // Process response data for table display
                    const { data, columns } = this.processResponseData(response);
                    
                    this.setState({
                        tableData: data,
                        columns: columns,
                        graphData: null,
                        busy: false,
                        errorPage: data.length === 0,
                        canDownload: data.length > 0
                    });
                })
                .catch((error) => {
                    console.error("Utilization Report Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        tableData: [],
                        columns: [],
                        graphData: null,
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Report Failed",
                            content: "Failed to fetch utilization report. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
        } else if (utilization_type === "utilization-graph") {
            ReportAPIs.getUtilizationReport(body)
                .then((response) => {
                    // Process response data for graph display
                    const graphData = this.processGraphData(response);
                    
                    this.setState({
                        graphData: graphData,
                        tableData: [],
                        columns: [],
                        busy: false,
                        errorPage: !graphData,
                        canDownload: !!graphData
                    });
                })
                .catch((error) => {
                    console.error("Utilization Graph Error:", error);
                    this.setState({
                        busy: false,
                        errorPage: true,
                        graphData: null,
                        tableData: [],
                        columns: [],
                        canDownload: false
                    });
                    this.props.props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                            name: "Graph Failed",
                            content: "Failed to fetch utilization graph. Please try again.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError: true
                        },
                    });
                });
        }
    }

    render(){
        return(
            <div className="monthlyReport">
                <div className="mrc-content">
                    <div className="mrcr-group">
                        <div className="mrcrg-selected">
                            <div className="mrc-select-all-toggle">
                                <label className="mrc-toggle-label">
                                    <input
                                        type="checkbox"
                                        checked={this.state.selectAllGroups}
                                        onChange={this.toggleSelectAllGroups}
                                        className="mrc-toggle-checkbox"
                                        disabled={this.state.utilization_type === "battery-swap" || this.state.utilization_type === "vehicle-usage"}
                                    />
                                    <span className="mrc-toggle-text">Select All Groups</span>
                                </label>
                            </div>
                            <div className={`mrcrgs-nav ${this.state.selectAllGroups || this.state.utilization_type === "battery-swap" ? 'disabled' : ''}`}>
                                <GroupNav
                                    props={this.state}
                                    navigate={this.navigate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mrc-controls-row">
                        <div className="mrcr-type" ref="reportContainer">
                            <div className="dropdown">
                                <div 
                                    className={this.state.dropdownOpen ? "dropdown-select-active" : "dropdown-select"} 
                                    onClick={this.toggleDropdown}
                                >
                                    {this.state.reportName ? this.state.reportName : "Select Report"}
                                </div>
                                {this.state.dropdownOpen && (
                                    <div className="dropdown-options">
                                        {this.getReportType()}
                                    </div>
                                )}
                            </div>
                        </div>
                        {this.state.utilization_type === "battery-swap" && (
                            <div className="mrc-vehicle-selection">
                                <InMultiSelect
                                    key={`battery-swap-vehicle-${this.state.utilization_type}`}
                                    ref={this.vehicleSelect}
                                    data={{
                                        storeData: (state) => {
                                            let newMap = {};
                                            for (let idx in state.vehicleMap) {
                                                if (idx.indexOf("user") === -1) {
                                                    newMap[idx] = state.vehicleMap[idx];
                                                }
                                            }
                                            return {
                                                data: newMap,
                                                name: "vehicleno",
                                                id: "vehicleid",
                                            };
                                        },
                                        key: 'vehicle',
                                        singleSelect: true,
                                        onItemChange: this.changeVehicle.bind(this),
                                        schemaKey: "utilization_report",
                                        defaultValue: () => {
                                            // Return empty array to ensure fresh start
                                            return {
                                                data: [],
                                                updatedAt: Date.now(),
                                            };
                                        }
                                    }}
                                />
                            </div>
                        )}
                        <div className={`mrc-date-selection ${this.state.utilization_type === "operational-status" ? 'disabled' : ''}`}>
                            <div 
                                className="mrcrd-picker"
                                onClick={(e) => {
                                    if (this.state.utilization_type === "operational-status") {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.props.props.dispatch({
                                            type: "ADD_INTOAST",
                                            data: {
                                                name: "Date Selection Disabled",
                                                content: "Date selection is disabled for Operational Status report.",
                                                createAt: Date.now(),
                                                autoClose: 4000,
                                                showError: true
                                            },
                                        });
                                    }
                                }}
                            >
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.startDate}
                                    onChange={(e) => this.handleStartDate(e)}
                                    dateFormat="dd-MM-yyyy"
                                    maxDate={moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                                    placeholderText="Start Date"
                                    disabled={this.state.utilization_type === "operational-status"}
                                    readOnly={this.state.utilization_type === "operational-status"}
                                />
                            </div>
                            <div 
                                className="mrcrd-picker"
                                onClick={(e) => {
                                    if (this.state.utilization_type === "operational-status") {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.props.props.dispatch({
                                            type: "ADD_INTOAST",
                                            data: {
                                                name: "Date Selection Disabled",
                                                content: "Date selection is disabled for Operational Status report.",
                                                createAt: Date.now(),
                                                autoClose: 4000,
                                                showError: true
                                            },
                                        });
                                    }
                                }}
                            >
                                <DatePicker
                                    wrapperClassName="datepicker"
                                    selected={this.state.endDate}
                                    onChange={(e) => this.handleEndDate(e)}
                                    dateFormat="dd-MM-yyyy"
                                    maxDate={moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                                    placeholderText="End Date"
                                    disabled={this.state.utilization_type === "operational-status"}
                                    readOnly={this.state.utilization_type === "operational-status"}
                                />
                            </div>
                        </div>
                        <div className="mrcr-download">
                            <button 
                                className={`mrcr-btn ${!this.isFormValid() ? 'disabled' : ''}`}
                                onClick={this.getReport}
                                disabled={!this.isFormValid()}
                            >
                                Get Report
                            </button>
                            <button 
                                className={`mrcr-btn-icon ${!this.state.canDownload ? 'disabled' : ''}`}
                                onClick={this.downloadReport}
                                title="Download"
                                disabled={!this.state.canDownload}
                            >
                                <i className="fa fa-download" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                {this.state.utilization_type === "vehicle-usage" && this.state.vehicleUsageSummary ? (
                    <div className="mrc-usage-summary">
                        {[
                            { label: "Group", value: this.state.vehicleUsageSummary.groupname },
                            { label: "Total Vehicles", value: this.state.vehicleUsageSummary.noofvehicles },
                            { label: "Operational", value: this.state.vehicleUsageSummary.operationalvehicles },
                            { label: "Non Operational", value: this.state.vehicleUsageSummary.nonoperationalvehicles },
                            { label: "Avg Km", value: this.state.vehicleUsageSummary.avgkm },
                            { label: "Max Km", value: this.state.vehicleUsageSummary.maxkm },
                            { label: "Total Km", value: this.state.vehicleUsageSummary.totalkm },
                        ].map((item, idx) => (
                            <div className="summary-item" key={`usage-summary-${idx}`}>
                                <div className="label">{item.label}</div>
                                <div className="value">{item.value ?? "-"}</div>
                            </div>
                        ))}
                    </div>
                ) : null}
                    <div className="mrc-table-section">
                        <div className="mrc-group-table">
                            {this.state.utilization_type === "utilization-graph" && this.state.graphData ? (
                                <ReusableGraph
                                    graphConfig={this.getGraphConfig()}
                                    height={600}
                                />
                            ) : null}
                            {this.state.utilization_type === "vehicle-usage" && this.state.vehicleUsageGraphData ? (
                                <ReusableGraph
                                    graphConfig={this.getVehicleUsageGraphConfig()}
                                    height={600}
                                    onChartClick={this.handleVehicleUsageBarClick}
                                />
                            ) : null}
                            {(this.state.utilization_type === "utilization-report" || this.state.utilization_type === "operational-status" || this.state.utilization_type === "battery-swap") && this.state.tableData && this.state.tableData.length > 0 && this.state.columns.length > 0 ? (
                                <GroupTable
                                    data={this.state.tableData}
                                    columns={this.state.columns}
                                />
                            ) : null}
                            {this.state.busy ? (
                                <div className="mrc-table-loader">
                                    <div className="loading">Loading...</div>
                                </div>
                            ) : null}
                            {this.state.errorPage && !this.state.busy ? (
                                <div className="mrc-error-page">
                                    <div>NO DATA</div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
                {/* Vehicle Usage Table Popup */}
                {this.state.showVehicleUsagePopup && (
                    <div className="mrc-vehicle-usage-modal">
                        <div className="mrc-modal-backdrop" onClick={this.handleVehicleUsagePopupClose}></div>
                        <div className="mrc-modal-content">
                            <div className="mrc-modal-header">
                                <div className="mrc-modal-header-content">
                                    <div className="mrc-modal-title">
                                        Group: {this.state.selectedGroupForTable ? (this.state.selectedGroupForTable.groupname || 'Unknown') : ''}
                                    </div>
                                    {this.state.selectedGroupForTable && (
                                        <div className="mrc-modal-summary">
                                            {[
                                                { label: "Total Vehicles", value: this.state.selectedGroupForTable.noofvehicles },
                                                { label: "Operational", value: this.state.selectedGroupForTable.operationalvehicles },
                                                { label: "Non Operational", value: this.state.selectedGroupForTable.nonoperationalvehicles },
                                                { label: "Avg Km", value: this.state.selectedGroupForTable.avgkm },
                                                { label: "Max Km", value: this.state.selectedGroupForTable.maxkm },
                                                { label: "Total Km", value: this.state.selectedGroupForTable.totalkm },
                                            ].map((item, idx) => (
                                                <div className="summary-item" key={`modal-summary-${idx}`}>
                                                    <div className="label">{item.label}</div>
                                                    <div className="value">{item.value ?? "-"}</div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="mrc-modal-close" onClick={this.handleVehicleUsagePopupClose}>
                                    <i className="fa fa-times"></i>
                                </div>
                            </div>
                            <div className="mrc-modal-body">
                                <div className="mrc-popup-table-wrapper">
                                    {this.state.tableData && this.state.tableData.length > 0 && this.state.columns.length > 0 ? (
                                        <GroupTable
                                            data={this.state.tableData}
                                            columns={this.state.columns}
                                        />
                                    ) : (
                                        <div className="mrc-no-table-data">No data available for this group.</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
export default MonthlyReport;
